import { createFeatureSelector, createSelector } from '@ngrx/store';
import { openFileState, openFileFeatureKey } from '../reducers/open-file.reducer';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import * as openAFileState from '../reducers/open-file.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, openFileState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee previous Selfie SUB STATE
export const getOpenFileState = createSelector(getMainEmployeeState, state => state[openFileFeatureKey]);
//#endregion

//#region Employee open file SUB STATE
export const getOpenFileRequest = createSelector(getOpenFileState, openAFileState.getOpenFileRequest);
export const getOpenFileSuccess = createSelector(getOpenFileState, openAFileState.getOpenFileResponse);
export const getOpenFileFailure = createSelector(getOpenFileState, openAFileState.getOpenFileFailure);

export const getUploadedFile = createSelector(getOpenFileState, openAFileState.getSavedBase64);
//#endregion
